export const BASE_URL = "https://srv412786.hstgr.cloud:7132"